export interface IKIOSKModel {
  selectedPage : String,
  menusData:IKioskMenu[],
  welcomeMenus:IKioskMenu[],
  language:string,
  authSuccesful:boolean,
  emiratesData:any,
  emiratesId:number,
  appointmentsData: IAppointment[],
  tokenData:any,
  otherServicesMenus:IKioskOtherServiceMenu[],
  tokenType:number,
  kioskRefreshTime:number,
  kioskEndTime: any,
  kioskStartTime:any,
  kioskId:any,
  themeName:any,
  kioskIdentifier:any,
  kioskType:any, 
  locationId:any,
  patientId:number,
  logInMenus:boolean,
  loading:boolean,
  errorMessage:string,
  kioskConfigdata:IkioskConfigdata,
  isWalkin:IKioskOtherServiceMenu,
  isNewpatientRegistration:IKioskOtherServiceMenu,
  appoinmenttype:string,
  currentDateAndTime:any,
  authFailMessage:string,
  mobileNumber:any,
  otherserviceErrorMessage:any,
  promotionalData:any
}




export interface IkioskConfigdata {
kioskConfigId: number
kioskMessage: KioskMessage[]
pageTimeout: number
tokenPrintTimeout: number
}

export interface KioskMessage {
kioskmessageId: number
msgKey: string
msgValueAr: string
msgValueEn: string
}


export interface IKioskMenu {
  menuCode: string
  menuName: string
}

export interface IAppointment {
  appointmentId: number
  appointmentTime: string
  branchId: number
  branchNameAr: string
  branchNameEn: string
  branchType: string
  doctorName: string
  encounterId: string
  maxCheckinTime: number
  minCheckinTime: number
  mrnNo: string
  patientName: string
  serviceId: number
  serviceNameAr: string
  serviceNameEn: string
  serviceStatus: string
  tranId: string
}

export interface IappointmentRequest {
  kioskId: number
  patientId: number
}
export interface ImobileAuthRequest {
  dob: string
  locationId: number
  mobileNumber: string
}
export interface ICheckInRequest {
  accompanyVisitors: number
  checkInMode: string
  eventId: string
  kioskId: number
  locationId: number
  userId: number
}
export interface IOtherServicesTokenRequest {
  branchId: number
  kioskId: number
  locationId: number
  patientId: number
  sendSms: boolean
  mobileNo: string,
}

export interface IKioskOtherServiceMenu {
  branchId: number
  branchNameAr: string
  branchNameEn: string
  branchTypeCode: string
}

export enum IkioskTokenType {
  OTHERSERVICES = 1,
  CHECKIN = 2,
  NEWPATIENT = 3,
  WALKIN = 4
}


export enum IkioskMenuIds {
LOGINPAGE = "LOGINPAGE",
INSERTEMIRATESID = "EMIRATES",
SCANQR = "QRSCAN", 
INPUTMOBILE = "MOBILE",
NEWPATIENT = "NEWPATINET",
LANGUAGE = "LANGUAGE" ,
APPOINMENTS = "CL",
LAB = "LAB",
RADIOLOGY = "RG",
PHARMACY = "PH",
OTHERSERVICES = "OTHERSERVICES",
ERRORPAGE = "ERRORPAGE",
WELCOMEPAGE = "WELCOMEPAGE",
TOKEN = "TOKEN",
AUTHFAILED = "AUTHFAILED",
PROMOTIONALSLIDE = "PROMOTIONALSLIDE",
DOBPAGE = "DOBPAGE",
NEWPATIENTLANGUAGE = "NEWPATIENTLANGUAGE",
PAGELOADING="PAGELOADING"
}

export enum IbranchTypeCodes {
PHARMACY = "PH",
LAB="LAB",
RADIOLOGY = "RG",
CLINICAL = "CL",
NONCLINICAL = "NCL",
REGISTRATION = "REG",
PATITENTSERVICES = "PS"
}

export enum EkioskConfigMessageKeys {
NOAPPOINMENTSMES = "APPOINTMENT_NOT_FOUND",
FATCHINGMES = "MESSAGE_WHILE_FETCHING_THE_DATA",
MOBILEVALIDATION = "MOBILE_NUMBER_IS_NOT_VALID",
KIOSKNONWORKINGMES = "KIOSK_NON_WORKING_HOURS"
}
export enum ETokenStatus {
  SCHEDULED = "SCHEDULED"
}
 





